<template xmlns="http://www.w3.org/1999/html">
  <v-sheet style="position: fixed; height: 100%; width: 100%">
    <v-row v-if="$device.isDesktop" style="height: 100%">
      <v-col class="px-4 py-6 ml-3 mt-2 bg-dark-primary"
             lg="4"
             md="5"
             sm="6"
             style="max-height: 100% !important; max-width: 348px !important;">
        <slot name="navigationMenu"/>
      </v-col>
      <v-col sm="6" lg="8" md="7" style="height: 100% !important;">
        <NuxtPage/>
      </v-col>
    </v-row>
  </v-sheet>
  <v-container v-if="$device.isMobile" fluid class="h-100">
    <v-sheet class="h-100">
      <slot name="navigationDrawer"/>
      <NuxtPage/>
    </v-sheet>
  </v-container>
</template>
<script lang="ts" setup>
</script>
